var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('v-container',[_c('h1',[_vm._v("This is an about page")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }